import { render, staticRenderFns } from "./ReviewOrderInvoices.vue?vue&type=template&id=3ede1afc"
import script from "./ReviewOrderInvoices.vue?vue&type=script&lang=js"
export * from "./ReviewOrderInvoices.vue?vue&type=script&lang=js"
import style0 from "./ReviewOrderInvoices.vue?vue&type=style&index=0&id=3ede1afc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports